import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngxs/store';
import { PaymentsState, RemoveArTranAllocations } from '@aiwyn/common/payments';

@Component({
  selector: 'app-multi-invoice-view',
  templateUrl: './multi-invoice-view.component.html',
  styleUrls: ['./multi-invoice-view.component.scss'],
  standalone: false,
})
export class MultiInvoiceViewComponent {
  // Allows communication to parent component so the paymentIntentReviewAndPay function can be used.
  @Output() updateAmount: EventEmitter<any> = new EventEmitter();

  selectedPayables$ = this.store.select(PaymentsState.getSelectedPayables);

  constructor(
    private readonly store: Store,
  ) {}

  removePayable(arTranId: number): void {
    this.store.dispatch(new RemoveArTranAllocations(arTranId));
  }
}
